var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 121,
    viewBox: "0 0 135 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_1676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.967 118.604H101.621C99.3237 118.604 97.4609 116.756 97.4609 114.477C97.4609 112.199 99.3237 110.351 101.621 110.351H110.967C114.438 110.351 117.262 107.55 117.262 104.106V17.7529C117.262 14.3098 114.439 11.5078 110.967 11.5078H23.9176C20.4468 11.5078 17.6222 14.3088 17.6222 17.7529V104.106C17.6222 107.549 20.4458 110.351 23.9176 110.351H73.7494C76.0463 110.351 77.9091 112.199 77.9091 114.477C77.9091 116.756 76.0463 118.604 73.7494 118.604H23.9176C15.8589 118.604 9.30273 112.1 9.30273 104.106V17.7529C9.30273 9.7586 15.8589 3.25488 23.9176 3.25488H110.967C119.026 3.25488 125.582 9.7586 125.582 17.7529V104.106C125.582 112.1 119.026 118.604 110.967 118.604Z",
    fill: "url(#paint0_linear_727_1676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7494 118.604H23.9176C15.8589 118.604 9.30273 112.1 9.30273 104.106V54.6728C9.30273 46.6785 15.8589 40.1748 23.9176 40.1748H49.6614C51.9584 40.1748 53.8211 42.0227 53.8211 44.3013C53.8211 46.5799 51.9584 48.4277 49.6614 48.4277H23.9176C20.4468 48.4277 17.6222 51.2297 17.6222 54.6728V104.106C17.6222 107.549 20.4458 110.351 23.9176 110.351H73.7494C77.2202 110.351 80.0448 107.55 80.0448 104.106V79.3893C80.0448 77.1107 81.9075 75.2629 84.2045 75.2629C86.5015 75.2629 88.3643 77.1107 88.3643 79.3893V104.106C88.3643 112.1 81.8081 118.604 73.7494 118.604Z",
    fill: "url(#paint1_linear_727_1676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.262 57.2975C74.1977 57.2975 73.1324 56.895 72.3208 56.0888C70.6965 54.4775 70.6965 51.8647 72.3208 50.2534L94.7743 27.9795C96.3986 26.3682 99.0324 26.3682 100.657 27.9795C102.281 29.5908 102.281 32.2036 100.657 33.8149L78.2033 56.0888C77.3906 56.895 76.3263 57.2975 75.262 57.2975Z",
    fill: "url(#paint2_linear_727_1676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7155 53.8003C95.4185 53.8003 93.5557 51.9525 93.5557 49.6739V35.0249H78.7887C76.4917 35.0249 74.6289 33.1771 74.6289 30.8984C74.6289 28.6198 76.4917 26.772 78.7887 26.772H97.7155C100.012 26.772 101.875 28.6198 101.875 30.8984V49.6739C101.875 51.9525 100.012 53.8003 97.7155 53.8003Z",
    fill: "url(#paint3_linear_727_1676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1683 95.0871C36.104 95.0871 35.0397 94.6845 34.227 93.8783C32.6027 92.267 32.6027 89.6542 34.227 88.0429L56.6805 65.769C58.3049 64.1577 60.9387 64.1577 62.563 65.769C64.1873 67.3804 64.1873 69.9931 62.563 71.6045L40.1095 93.8783C39.2979 94.6835 38.2326 95.0871 37.1683 95.0871Z",
    fill: "url(#paint4_linear_727_1676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0963 95.087H37.1695C34.8725 95.087 33.0098 93.2391 33.0098 90.9605V72.1851C33.0098 69.9064 34.8725 68.0586 37.1695 68.0586C39.4665 68.0586 41.3293 69.9064 41.3293 72.1851V86.834H56.0963C58.3933 86.834 60.2561 88.6819 60.2561 90.9605C60.2561 93.2391 58.3933 95.087 56.0963 95.087Z",
    fill: "url(#paint5_linear_727_1676)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_727_1676",
    x1: 67.4423,
    y1: 3.25488,
    x2: 67.4423,
    y2: 118.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_727_1676",
    x1: 48.8335,
    y1: 40.1748,
    x2: 48.8335,
    y2: 118.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_727_1676",
    x1: 86.4888,
    y1: 26.771,
    x2: 86.4888,
    y2: 57.2975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_727_1676",
    x1: 88.2521,
    y1: 26.772,
    x2: 88.2521,
    y2: 53.8003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_727_1676",
    x1: 48.395,
    y1: 64.5605,
    x2: 48.395,
    y2: 95.0871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_727_1676",
    x1: 46.6329,
    y1: 68.0586,
    x2: 46.6329,
    y2: 95.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_1676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 116.279,
    height: 115.349,
    fill: "white",
    transform: "translate(9.30273 3.25488)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModular);
export default __webpack_public_path__ + "static/media/Modular.01cb3018958dc0368aca6f4f27718083.svg";
export { ForwardRef as ReactComponent };